import React from 'react';
import { translate } from 'components/Translation';
import Button from 'components/CustomButtons/Button';
import styles from 'assets/jss/material-dashboard-pro-react/components/reloadPageStyle';
import { makeStyles } from '@material-ui/core';
import classNames from 'classnames';
import { BodyM } from 'components/Typography/Typography';

// @ts-ignore
const useStyles = makeStyles(styles);

interface IReloadPageProps {
	reload: () => void;
	text: string;
	className?: string;
}

const ReloadPage = ({ reload, text, className }: IReloadPageProps) => {
	const classes = useStyles();

	return (
		<div className={classNames(classes.wrapper, className)}>
			<div>
				<BodyM disableMargin>{text}</BodyM>
			</div>
			<Button onClick={reload} color="primary-light">
				{translate('try.again.button')}
			</Button>
		</div>
	);
};

export default ReloadPage;
